import * as React from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';

const ClickableBlockLink = styled.div`
    &:hover {
        cursor: pointer;
    }
`;

interface IClickableBlock {
    className?: string;
    children: React.ReactNode;
    ariaLabel?: string;
    onClick?(): void;
}

export const ClickableBlock = observer(
    ({ className, children, ariaLabel, onClick }: IClickableBlock) => (
        <ClickableBlockLink
            className={className}
            aria-label={ariaLabel}
            role="button"
            onClick={onClick}
        >
            {children}
        </ClickableBlockLink>
    )
);
